import {
  CoverExtra,
  DeliveryGuaranteeExtra,
  ExtendedBaseCoverExtra,
  ExtrasTitle,
  PrintInStoreExtra,
  SignatureExtra,
  SmsExtra
} from '../../../ExtrasHelper';
import { Actions } from '../../rules/Actions';

const toExtraDisplayName = (extra: string): string => ExtrasTitle({ Id: extra, Name: '' }).replaceAll('\n', ' ');

export function toActionDisplayName(action: string): string {
  switch (action) {
    case Actions.Item_TariffCode:
      return 'Tariff Code';
    case Actions.Item_Height:
      return 'Height';
    case Actions.Item_Width:
      return 'Width';
    case Actions.Item_Length:
      return 'Length';
    case Actions.Item_Service:
    case Actions.Item_CourierService:
      return 'Service';
    case Actions.Item_Weight:
      return 'Weight';
    case Actions.Extra_Sms:
      return toExtraDisplayName(SmsExtra);
    case Actions.Extra_DeliveryGuarantee:
      return toExtraDisplayName(DeliveryGuaranteeExtra);
    case Actions.Extra_Cover:
      return toExtraDisplayName(CoverExtra);
    case Actions.Extra_ExtendedBaseCover:
      return toExtraDisplayName(ExtendedBaseCoverExtra);
    case Actions.Extra_PrintInStore:
      return toExtraDisplayName(PrintInStoreExtra);
    case Actions.Extra_Signature:
      return toExtraDisplayName(SignatureExtra);
    default:
      return action;
  }
}
